<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <agentVendorShop @select="selectHandler" />

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="scheduleName" label="名称"></el-table-column>
      <!-- <el-table-column
        prop="minimalAmount"
        label="最少消费金额"
      ></el-table-column> -->
      <el-table-column label="折扣率">
        <template slot-scope="scope">{{ `${scope.row.zhekou}%` }}</template>
      </el-table-column>
      <el-table-column prop="shopName" label="门店"></el-table-column>
      <el-table-column label="加盟商" v-if="userType === 'admin'">
        <template slot-scope="scope">{{
          $getVendorName(scope.row.vendorid)
        }}</template>
      </el-table-column>
      <el-table-column label="有效日期">
        <template slot-scope="scope">{{ filterWeek(scope.row.day) }}</template>
      </el-table-column>
      <el-table-column label="启用">
        <template slot-scope="scope">
          <div>
            <el-tag type="success" v-if="scope.row.isEnable">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <EditDialog
      v-if="isDialogShow"
      :isCreate="isCreate"
      :promotionItem="promotionItem"
      @closeForm="closeForm"
      @refreshData="onSubmit"
    />
  </div>
</template>

<script>
import agentVendorShop from "@/components/layout/agentVendorShop";
import EditDialog from "./components/editDialog";
//import { mapGetters } from "vuex";
export default {
  components: { agentVendorShop, EditDialog },
  data() {
    return {
      formInline: {
        agentid: undefined,
        vendorid: undefined,
        shopid: undefined,
        vendorName: "",
        shopName: ""
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: [],
      // vendorsList: [],
      // shopList: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],
      promotionItem: null,
      isDialogShow: false,
      userType: this.$getUserType()
    };
  },

  filters: {},

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.shopid = x.selectedShop.shopid;
    },
    onSubmit() {
      this.queryScheduledPromotion();
    },

    queryScheduledPromotion() {
      this.$axios(this.$urlMapping["查询定时促销"], {
        data: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          ...this.formInline
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    // filterVendor(vendorid) {
    //   let vendorNameItem = this.vendorsList.find(
    //     ele => ele && ele.vendorid === vendorid
    //   );
    //   if (vendorNameItem) {
    //     return vendorNameItem.vendorName;
    //   } else {
    //     return "无效的vendor【" + vendorid + "】";
    //   }
    // },
    filterWeek(day) {
      let weekArray = [1, 2, 4, 8, 16, 32, 64];
      let weekNameArray = [];
      weekArray.forEach((ele, index) => {
        if ((day & ele) === ele) {
          if (index === 0) {
            weekNameArray.push("周一");
          }
          if (index === 1) {
            weekNameArray.push("周二");
          }
          if (index === 2) {
            weekNameArray.push("周三");
          }
          if (index === 3) {
            weekNameArray.push("周四");
          }
          if (index === 4) {
            weekNameArray.push("周五");
          }
          if (index === 5) {
            weekNameArray.push("周六");
          }
          if (index === 6) {
            weekNameArray.push("周日");
          }
        }
      });
      if (weekNameArray.length === 0) {
        return "空";
      }
      return weekNameArray.join(";");
    },
    onAdd() {
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleEdit(item) {
      this.promotionItem = item;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    closeForm() {
      this.isDialogShow = false;
    }
  },
  async mounted() {
    // if (this.userType === "admin") {
    //   this.$queryVendorForPrompt(null, result => {
    //     this.vendorListForPrompt = result;
    //   });
    // }

    // await new Promise(resolve => {
    //   this.$axios(this.$urlMapping["查询门店"], {
    //     data: {}
    //   }).then(result => {
    //     this.shopList = result.data.map(ele => ele.shopInfoEntity);
    //     resolve();
    //   });
    // });
    this.queryScheduledPromotion();
  }
};
</script>

<style lang="less" scoped></style>
